"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./WindowResize.css");
var debounce = require("lodash/debounce");
/* istanbul ignore next */
var getWindowWidth = function () { return Math.max(document.documentElement.clientWidth, window.innerWidth || 0); };
var WindowResize = (function (_super) {
    __extends(WindowResize, _super);
    function WindowResize(props) {
        var _this = _super.call(this, props) || this;
        /* istanbul ignore next */
        _this._resized = _this._resized.bind(_this);
        /* istanbul ignore next */
        _this._onBreakpoint = _this._onBreakpoint.bind(_this);
        /* istanbul ignore next */
        _this._getSizeOfMedia = _this._getSizeOfMedia.bind(_this);
        return _this;
    }
    /* istanbul ignore next */
    WindowResize.onResize = function () {
        var width = getWindowWidth();
        WindowResize.listeners.forEach(function (listener) { return listener(width); });
    };
    /* istanbul ignore next */
    WindowResize.prototype.componentDidMount = function () {
        if (!WindowResize.listeners.length) {
            WindowResize.onResize = debounce(WindowResize.onResize, 200);
            window.addEventListener('resize', WindowResize.onResize);
        }
        WindowResize.listeners.push(this._resized);
        WindowResize.onResize();
    };
    /* istanbul ignore next */
    WindowResize.prototype.componentWillUnmount = function () {
        var _this = this;
        WindowResize.listeners = WindowResize.listeners.filter(function (listener) { return listener !== _this._resized; });
        if (!WindowResize.listeners.length) {
            window.removeEventListener('resize', WindowResize.onResize);
        }
    };
    /* istanbul ignore next */
    WindowResize.prototype._resized = function (width) {
        this._onBreakpoint(this._getSizeOfMedia(width));
    };
    WindowResize.prototype._onBreakpoint = function (breakpoint) {
        this.props.onBreakpoint && this.props.onBreakpoint(breakpoint);
    };
    /* istanbul ignore next */
    WindowResize.prototype._getSizeOfMedia = function (width) {
        var mediaBreakpoints = {
            'Xl': this.props.breakpointXl,
            'Lg': this.props.breakpointLg,
            'Md': this.props.breakpointMd,
            'Sm': this.props.breakpointSm,
            'Xs': this.props.breakpointXs
        };
        for (var size in mediaBreakpoints) {
            if (width >= mediaBreakpoints[size]) {
                return size;
            }
        }
        return 'Min';
    };
    WindowResize.prototype.render = function () {
        return (React.createElement("div", { className: "p-window-resize", "data-tag": this.props.tag }, this.props.children));
    };
    return WindowResize;
}(React.Component));
/* istanbul ignore next */
WindowResize.defaultProps = {
    tag: '',
    breakpointXs: 480,
    breakpointSm: 600,
    breakpointMd: 840,
    breakpointLg: 960,
    breakpointXl: 1280,
    onBreakpoint: void (0),
    children: []
};
WindowResize.listeners = [];
exports.default = WindowResize;
//# sourceMappingURL=WindowResize.js.map


//////////////////
// WEBPACK FOOTER
// ../player-window-resize/build/control/WindowResize.js
// module id = 373
// module chunks = 0